/* eslint-disable */
// src/components/common/ErrorBoundary.js

/* 
 * Captura errores de renderizado en cualquier subárbol React.
 * Muestra un mensaje simple y evita que la app “explote”.
 * Ideal para envolver páginas críticas; extensible a logger remoto.
 */

import React from "react";
import PropTypes from "prop-types";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: "" };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, message: error?.message || "Ocurrió un error" };
  }

  componentDidCatch(error, info) {
    // Log en dev únicamente
    if (process.env.NODE_ENV !== "production") {            
      console.error("ErrorBoundary:", error, info);         
    }   
    // Delegar al handler externo (logger/notify) si viene
    if (typeof this.props.onError === "function") {         
      try { this.props.onError(error, info); } catch {}     
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <MDBox pt={6} pb={3}>
          <MDTypography variant="h6" color="error">
            {this.state.message}
          </MDTypography>
        </MDBox>
      );
    }
    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node,
  onError: PropTypes.func,
};

ErrorBoundary.defaultProps = {
  onError: null,
};
